<template>

    <div id="app">
        <div class="main-background-image" id="mainBackgroundImage"></div>

        <search-wrapper></search-wrapper>

        <main-header></main-header>

        <div class="main-content-wrapper">
            <router-view></router-view>

        </div>

        <main-footer></main-footer>
    </div>

</template>

<script>
    import Header from './Header.vue';
    import Footer from './Footer.vue';
    import Search from './Search.vue';

    export default {
        components: {
            "main-header": Header,
            "main-footer": Footer,
            "search-wrapper": Search,
        },
        name: 'app',

        computed: {

        },

        methods: {


        },
        mounted: function() {


        }
    }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/layout/Template.vue